import {MantineProvider} from "@mantine/core";
import "@mantine/core/styles.css";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {RouterProvider} from "@tanstack/react-router";
import "./global.css";
import {AuthProvider} from "@/app/auth";
import {router} from "@/app/routes";
import {theme} from "@/app/ui/theme";

const queryClient = new QueryClient();

export function App() {
  return (
    <MantineProvider theme={theme} defaultColorScheme="auto">
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </QueryClientProvider>
    </MantineProvider>
  );
}

export default App;
